import '@revolut-internal/zod-commons/setup'

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ThemeProvider, BreakpointsProvider, DefaultTheme } from '@revolut/ui-kit'
import { MemoryRouter } from 'react-router-dom'
import { store } from './store'
import App from './App'
import { GlobalStyle } from './GlobalStyle'
import { setupSentry } from './setupSentry'

setupSentry()

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={DefaultTheme}>
      <BreakpointsProvider>
        <React.Fragment>
          <GlobalStyle />
          <MemoryRouter initialEntries={[{ pathname: '/personal' }]} initialIndex={0}>
            <App />
          </MemoryRouter>
        </React.Fragment>
      </BreakpointsProvider>
    </ThemeProvider>
  </Provider>,
  document.getElementById('mount'),
)
